import { createAsyncThunk } from "@reduxjs/toolkit";
import { ImageModelProps } from "../../types/interface";
import { IMAGES_FETCH_IMAGES_LIST_BY_ID } from "../../constants";
import AxiosInstance from "../../Service/AxiosInstance";

const baseURL = `${process.env.REACT_APP_SERVER_BASEURL}`;

export const fetchImageListById = createAsyncThunk<
  ImageModelProps,
  string,
  { rejectValue: string }
>(IMAGES_FETCH_IMAGES_LIST_BY_ID, async (id, { rejectWithValue }) => {
  try {
    const response = await AxiosInstance.get(
      `${baseURL}/api/Images/GetAll?projectId=${id}&page=${1}&pageSize=${40}`
    );
    return response.data;
  } catch (error) {
    return rejectWithValue("Failed to fetch image list");
  }
});
